import * as React from 'react';
import { SVGProps } from 'react';

const CopiedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.92 3H2.08c-.263 0-.49 0-.678.015a1.527 1.527 0 0 0-.583.148 1.5 1.5 0 0 0-.656.656c-.096.19-.132.386-.148.583A8.95 8.95 0 0 0 0 5.081v3.838c0 .264 0 .491.015.679.016.197.052.394.148.583a1.5 1.5 0 0 0 .656.655c.19.097.386.133.583.149.188.015.415.015.679.015h3.838c.264 0 .491 0 .679-.015.197-.016.394-.052.583-.149a1.5 1.5 0 0 0 .656-.655c.096-.19.132-.386.148-.583C8 9.41 8 9.183 8 8.919V5.081c0-.264 0-.491-.015-.679a1.527 1.527 0 0 0-.148-.583 1.5 1.5 0 0 0-.656-.656 1.527 1.527 0 0 0-.583-.148C6.41 3 6.183 3 5.919 3Zm.184 3.104a.5.5 0 1 0-.708-.708L3.5 7.293l-.646-.647a.5.5 0 0 0-.708.708l1 1a.5.5 0 0 0 .708 0l2.25-2.25Z"
      fill="currentColor"
    />
    <path
      d="M8.92 0H5.08c-.263 0-.49 0-.678.015a1.527 1.527 0 0 0-.583.148 1.5 1.5 0 0 0-.656.656c-.096.19-.132.386-.148.583A7.816 7.816 0 0 0 3 2h2.94c.245 0 .51 0 .739.019.26.02.602.073.956.253a2.5 2.5 0 0 1 1.093 1.093c.18.354.232.697.253.956.02.23.02.494.019.739V8c.23 0 .43-.002.598-.015.197-.016.394-.052.583-.148a1.5 1.5 0 0 0 .655-.656c.097-.19.133-.386.149-.583C11 6.41 11 6.183 11 5.919V2.081c0-.264 0-.491-.015-.679a1.526 1.526 0 0 0-.149-.583 1.5 1.5 0 0 0-.655-.656 1.527 1.527 0 0 0-.583-.148A8.951 8.951 0 0 0 8.919 0Z"
      fill="currentColor"
    />
  </svg>
);

export default CopiedIcon;
